import { normalizeUniqueStringList } from "./externalAccess";

const SLACK_WEBHOOK_URL_REGEX =
  /^https:\/\/hooks\.slack(?:-gov)?\.com\/services\/[A-Za-z0-9/_-]+$/;

export const parseSlackWebhookUrls = (value) =>
  normalizeUniqueStringList(String(value || "").split(/[\n,]/));

export const buildSlackWebhookValidationError = (urls) => {
  if (!Array.isArray(urls) || urls.length === 0) {
    return "Add at least one Slack webhook URL.";
  }
  const invalidUrl = urls.find((url) => !SLACK_WEBHOOK_URL_REGEX.test(url));
  if (invalidUrl) {
    return `Invalid Slack webhook URL format: ${invalidUrl}`;
  }
  return "";
};

export const extractSaveErrorMessage = (error, fallback) => {
  const responseData = error?.response?.data;
  if (typeof responseData === "string" && responseData.trim()) {
    return responseData.trim();
  }
  if (responseData && typeof responseData.message === "string") {
    const message = responseData.message.trim();
    if (message) return message;
  }
  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message.trim();
  }
  if (typeof fallback === "string" && fallback.trim()) {
    return fallback.trim();
  }
  return "We couldn't save this agent configuration. Check required tool settings and try again.";
};
